exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn{cursor:pointer;font-weight:600;padding-top:.75rem;padding-bottom:.75rem;padding-left:1.5rem;padding-right:1.5rem;border-radius:.25rem;display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn-blue{background-color:#4299e1;color:#fff}.btn-blue:hover{background-color:#2b6cb0}.btn-blue:active{background-color:#2c5282}.btn-blue:focus{-webkit-box-shadow:0 0 0 3px rgba(66,153,225,.5);box-shadow:0 0 0 3px rgba(66,153,225,.5)}", ""]);

// exports
